import { HttpMethod } from 'app/utils/network';
import { API } from 'app/utils/request';

export const addAccount = (accountRequest, authToken) => {
  const urlPath = '/account/addAccount';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: accountRequest,
    additionalHeader: additionalHeader
  });
};

export const updateAccount = (accountRequest, authToken) => {
  const urlPath = '/account/updateAccount';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: accountRequest,
    additionalHeader: additionalHeader
  });
};

export const getAccountDetailsById = (patientId, authToken) => {
  const urlPath = `/account/getAccountByRefPatientId/${patientId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const removeAccountById = (accountId, authToken) => {
  const urlPath = `/account/removeAccount/${accountId}`;
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.DELETE,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const getAllAccountDetails = (authToken) => {
  const urlPath = '/account/getAllAccountDetails';
  const additionalHeader = {Authorization: `Bearer ${authToken}`}
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};
